import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'help_center-home_page-view';
/**
 * help center home page rendering event
 */
export function trackHelpCenterHomePageView(retailerToken, brandToken) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: { retailerToken, brandToken },
    });
}
/**
 * Trace for event: help_center-home_page-view
 */
export function trackHelpCenterHomePageViewTraceApiRequestEnd(sourceEventMarker) {
    trackClientEvent({
        eventKey: 'help_center-home_page-view-trace-api_request_end',
        realTimeTracking: false,
        sourceEventKey: 'help_center-home_page-view',
        sourceEventMarker: sourceEventMarker,
    });
}
/**
 * Trace for event: help_center-home_page-view
 */
export function trackHelpCenterHomePageViewTraceApiRequestStart(sourceEventMarker) {
    trackClientEvent({
        eventKey: 'help_center-home_page-view-trace-api_request_start',
        realTimeTracking: false,
        sourceEventKey: 'help_center-home_page-view',
        sourceEventMarker: sourceEventMarker,
    });
}
/**
 * Trace for event: help_center-home_page-view
 */
export function trackHelpCenterHomePageViewTraceRendered(sourceEventMarker) {
    trackClientEvent({
        eventKey: 'help_center-home_page-view-trace-rendered',
        realTimeTracking: false,
        sourceEventKey: 'help_center-home_page-view',
        sourceEventMarker: sourceEventMarker,
    });
}
